import {
  CommunicationAudienceType,
  CommunicationPublishedStatus,
} from "../config/enums";
import { enumToOptions } from "../blocks/fields/enumToOptions";
import { ListFilterDefinition } from "./listFilters.types";

export const communicationStatusOptions = enumToOptions(CommunicationPublishedStatus);
export const communicationTypeOptions = enumToOptions(CommunicationAudienceType);

/**
 * The filters on a communications table, wherever one is shown. The campaign filter is
 * the list's own: a campaign's table is already that campaign's.
 */
export const communicationFilters: ListFilterDefinition[] = [
  {
    name: "Name",
    label: "Name",
    kind: "text",
    searchFields: ["Name"],
    width: "wider",
  },
  {
    name: "statuscode",
    label: "Status",
    kind: "picklist",
    options: communicationStatusOptions,
  },
  {
    name: "g4c_communicationtype",
    label: "Type",
    kind: "picklist",
    options: communicationTypeOptions,
  },
  {
    name: "hideExpired",
    label: "Hide Expired Communications",
    kind: "boolean",
    toggle: true,
    advanced: true,
    hidePast: "g4c_enddate",
  },
  {
    name: "g4c_startdate",
    label: "Start Date",
    kind: "date-range",
    advanced: true,
  },
  {
    name: "g4c_enddate",
    label: "End Date",
    kind: "date-range",
    advanced: true,
  },
  { name: "createdon", label: "Created", kind: "date-range", advanced: true },
  {
    name: "modifiedon",
    label: "Modified",
    kind: "date-range",
    advanced: true,
  },
];
